import { render, staticRenderFns } from "./ViHomeOthers.vue?vue&type=template&id=79bb5d43&scoped=true"
import script from "./ViHomeOthers.vue?vue&type=script&lang=js"
export * from "./ViHomeOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bb5d43",
  null
  
)

export default component.exports